import { StateSchema } from 'app/config/storeConfig/types';
import { ExportModalSchema } from '../types';

export const getExportModalState = (state: StateSchema): ExportModalSchema => state.exportModal;
